// extracted by mini-css-extract-plugin
export default {"event":"Invite_event__YQ1ab","slidein":"Invite_slidein__D2nBy","image":"Invite_image__y2oNt","date":"Invite_date__4iVZW","highlight":"Invite_highlight__ogWGT"};